var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.564,
    height: 25.564,
    viewBox: "0 0 25.564 25.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 27.564) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.782,2A12.782,12.782,0,1,0,27.564,14.782,12.782,12.782,0,0,0,14.782,2Zm0,23.24A10.458,10.458,0,1,1,25.24,14.782,10.458,10.458,0,0,1,14.782,25.24Z",
    fill: "#15b5d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.218,23.574l-4.989-4.988-1.643,1.643,5.81,5.81a1.162,1.162,0,0,0,1.643,0l5.81-5.81-1.643-1.643Z",
    transform: "translate(-4.435 -6.949)",
    fill: "#15b5d8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapsed);
export default __webpack_public_path__ + "static/media/collapsed.68df1fe246370a2b9e76e9e90b59c201.svg";
export { ForwardRef as ReactComponent };